import { Edit, View } from 'assets/Icons'
import { Pagination } from 'components/index'
import { Tooltip } from 'components/Overlay'
import Table from 'components/Table/index'
import { prettyDate } from 'helpers/prettyData'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import services from 'services/index'
import { Head, Header } from './components'
import DeleteTeacher from './components/DeleteTeacher'
import { deafaultFilter } from './constants'

const Teacher = () => {
	const navigate = useNavigate()
	const role = useSelector(state => state?.user?.user?.user_type)
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])
	const [totalItemsCount, setTotalItemsCount] = useState(0)
	const [filter, setFilter] = useState(deafaultFilter)
	const { page, page_size } = filter

	const getTeachers = filter => {
		const options = {
			filter,
			onEnd: () => setLoading(false),
			onError: () => setData([]),
			onStart: () => setLoading(true),
			onSuccess: response => {
				setTotalItemsCount(response?.data?.count)
				setData(response?.data?.results)
			},
		}
		services.teachers.getTeachers(options)
	}
	useEffect(() => {
		getTeachers(filter)
	}, [filter])

	const onChangePage = value => {
		const newFilter = { ...filter, ...value }
		setFilter(newFilter)
	}

	const headers = useMemo(() => {
		const headers = [
			{
				key: 'order',
				label: <div className='min-w-[20px] text-center sm:text-start'>№</div>,
				getContent: ({ data, key, index }) => {
					const order = index + 1
					return <div className='text-center sm:text-start'>{order}</div>
				},
			},
			{
				key: 'first_name',
				label: 'Ism',
				getContent: ({ data, key, index }) => {
					const name = data?.first_name
					return <div className='text-start'>{name}</div>
				},
			},
			{
				key: 'last_name',
				label: 'Familiya',
				getContent: ({ data, key, index }) => {
					const name = data?.last_name
					return <div className='text-start'>{name}</div>
				},
			},
			{
				key: 'birth_date',
				label: "Tug'ilgan sana",
				getContent: ({ data, key, index }) => {
					const date = data?.birth_date
					return (
						<div className='text-start'>{date ? prettyDate(date) : '-'}</div>
					)
				},
			},
			{
				key: 'phone_number',
				label: 'Telefon raqami',
				getContent: ({ data, key, index }) => {
					const phone = data?.phone_number || '-'
					return <div className='text-start'>{phone}</div>
				},
			},
			{
				key: 'actions',
				label: 'Amallar',
				getContent: ({ data, key, index }) => {
					const id = data?.id
					return (
						<div className='flex justify-center sm:justify-start items-center'>
							<Tooltip
								title={role === 'admin' ? 'Tahrirlash' : "Ko'rish"}
								distance={6}
							>
								<button
									className='edit-icon'
									onClick={() =>
										navigate(`/account/teachers/update/${id}`, {
											state: { updateData: data },
										})
									}
								>
									{role === 'admin' ? <Edit /> : <View />}
								</button>
							</Tooltip>
							{role === 'admin' ? (
								<DeleteTeacher
									id={id}
									filter={filter}
									getTeachers={getTeachers}
								/>
							) : (
								<></>
							)}
						</div>
					)
				},
			},
		]
		return headers
	}, [filter, getTeachers])

	return (
		<div className='sm:p-6 p-3'>
			<Head />
			<Header filter={filter} setFilter={setFilter} />
			<Table isLoading={loading} data={data} headers={headers} />
			<div className='pt-[20px]'>
				<Pagination
					isDisabled={loading}
					onChange={onChangePage}
					page={page}
					page_size={page_size}
					totalItemsCount={totalItemsCount}
				/>
			</div>
		</div>
	)
}

export default Teacher
